import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './BottomNav.module.css';
import { FaChartLine, FaChartPie, FaBriefcase, FaUser, FaChartBar } from 'react-icons/fa'; // Added FaChartBar

const BottomNav = ({ isDisabled }) => {
  const navClassName = `${styles['bottom-nav']} ${isDisabled ? styles['disabled-interaction'] : ''}`;

  return (
    <nav className={navClassName}>
      <div className={styles['nav-bg-container']}>
        <div className={styles['nav-bg']} />
      </div>
      <NavLink to="/" end className={({ isActive }) => (isActive ? `${styles['nav-item']} ${styles.active}` : styles['nav-item'])}>
        <FaChartLine />
        <span>Markets</span>
      </NavLink>
      <NavLink to="/watchlist" className={({ isActive }) => (isActive ? `${styles['nav-item']} ${styles.active}` : styles['nav-item'])}>
        <FaChartPie />
        <span>Watchlist</span>
      </NavLink>
      <NavLink to="/trade" className={({ isActive }) => (isActive ? `${styles['nav-item']} ${styles.active}` : styles['nav-item'])}>
        <div className={styles['center-item']}>
          <FaChartBar />
        </div>
        <span>Trade</span>
      </NavLink>
      <NavLink to="/positions" className={({ isActive }) => (isActive ? `${styles['nav-item']} ${styles.active}` : styles['nav-item'])}>
        <FaBriefcase />
        <span>Portfolio</span>
      </NavLink>
      <NavLink to="/profile" className={({ isActive }) => (isActive ? `${styles['nav-item']} ${styles.active}` : styles['nav-item'])}>
        <FaUser />
        <span>Profile</span>
      </NavLink>
    </nav>
  );
};

export default BottomNav;
